import React from "react";
import { Box } from "@mui/material";
import { keyframes } from "@mui/system";

// Same "blink light" shimmer used on the home page service loading skeletons.
const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const Shimmer = ({ width = "100%", height = 16, radius = "10px", sx }) => (
  <Box
    sx={{
      width,
      height,
      borderRadius: radius,
      flexShrink: 0,
      background:
        "linear-gradient(90deg, #f0e6e0 0%, #fdf6f1 40%, #f5ece6 60%, #f0e6e0 100%)",
      backgroundSize: "400px 100%",
      animation: `${shimmer} 1.4s ease-in-out infinite`,
      ...sx,
    }}
  />
);

export default Shimmer;
